import React, { InputHTMLAttributes, ReactNode, useEffect, useState, } from 'react';
import { Table } from "flowbite-react";

import CustomThemeTable from '../CustomThemes/CustomThemeTable';
import { IRequestMemberType } from '../../types/IRequestMemberType';

interface ViewMembersFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    itemNumber?: number;
    labelName?: ReactNode;
    value: string;
}

const ViewTextField: React.FC<ViewMembersFieldProps> = ({ itemNumber, labelName, value }) => {
    return (
        <div className="mb-8">
            <div className="flex">
                <div className="flex-none w-5 text-sm">{itemNumber}.</div>
                <div className="text-sm">{labelName}</div>
            </div>
            <div className="flex">
                <div className="flex-none w-5"></div>
                <div className="grow mt-3">
                    <div className="text-blue-600 dark:text-green-700">{value}</div>
                </div>
            </div>
        </div>
    )
}

export default ViewTextField;